import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Privaciadade from "@/components/Privacidade"
import Termo from "@/components/Termo"
import Captive from "@/components/Captive"

Vue.use(Router)

export default new Router({
  routes: [{
      path: '/',
      name: 'Captive',
      component: Captive
    },
    {
      path: '/privacidade',
      name: 'Privacidade',
      component: Privaciadade
    },
    {
      path: '/termo',
      name: 'Termo',
      component: Termo
    }
    /* ,
        {
          path: '/captive',
          name: 'Captive',
          component: Captive
        } */
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js